<template>
  <div class="mt-5">
    <form @submit.prevent="userUpdate">

      <h3>User Edit</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <div class="form-group">
        <label>Email</label>
        <input type="text" class="form-control form-control-lg" v-model="email"/>
      </div>

      <div class="form-group">
        <label>Role</label>
        <select class="form-control" v-model="selected">
          <option v-for="role in roles" v-bind:value="role" v-bind:key="role" class="form-control form-control-lg">
            {{ role }}
          </option>
        </select>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Update</button>

    </form>
  </div>
</template>

<script>
import axios from "axios";
import tokenRefresh from "@/utils/tokenRefresh";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "UserEdit.vue",
  data() {
    return {
      name: '',
      email: '',
      roles: '',
      selected: '',
    }
  },
  mounted() {
    let userId = window.location.pathname.split("/").pop();
    axios.get(process.env.VUE_APP_CRAWLING_URL + "/api/user/edit/" + userId)
        .then((response) => {
              this.name = response.data.user.name;
              this.email = response.data.user.email;
              this.selected = response.data['user-role'];
              this.roles = response.data.roles;
            }
        )
  },
  methods: {
    userUpdate: function () {
      let userId = window.location.pathname.split("/").pop();
      const {name, email, selected} = this;
      axios.put(process.env.VUE_APP_CRAWLING_URL + "/api/user/" + userId, {name, email, "role": selected})
          .then((response) => {
                if (response.status === 200) {
                  tokenRefresh()
                  this.$router.push({name: "users"});
                }
              }
          )
          .catch((error) => {
                statusCheck(error.response.status);
              }
          )
    }
  }
}
</script>

<style scoped>

</style>